import { api_GET, api_POST, api_DELETE, api_POSTFile } from "api/_axios.js";

const dre_api =
{
    getList: function (mesano) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DREExcecoes/${mesano}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DREExcecoes`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    delete: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`DREExcecoes`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getCsvTemplateImport: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DREExcecoes/modeloCsvImport`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postImportCsv: function (usuarioId, formData) {
        const promise = new Promise((resolve, reject) => {
            api_POSTFile(`DREExcecoes/uploadcsvExcecoes/${usuarioId}`, formData).then(result => {
                resolve(result)
            });
        });
        return promise;
    }
}

export default dre_api
